const CciHsCodeClassificationApiUrls = {
    SEARCH: `${process.env.REACT_APP_USER_CCI_URL}/cci/hs-recommendations/search`,
    RETRY: `${process.env.REACT_APP_USER_CCI_URL}/cci/hs-recommendations/retry`,
};
export default CciHsCodeClassificationApiUrls